module.exports = __webpack_public_path__ + "img/single_pictures_3.ac430ed3.jpg";